import { TranslatePipe } from '../../filters/translate.pipe';
import { CardClaimsHistoryComponent } from '../../components/card-claims-history/card-claims-history.component';
import { CardInsurancePoliciesComponent } from '../../components/card-insurance-policies/card-insurance-policies.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import $ from 'jquery';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { PanelDirective } from '../../directives/panel.directive';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'insurance',
	templateUrl: './insurance.component.html',
	imports: [
		CommonModule, PanelDirective, TranslatePipe, CardClaimsHistoryComponent, 
		CardInsurancePoliciesComponent, FormsModule, RouterLink
	]
})
export default class InsuranceView implements OnInit, OnDestroy {
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	private router: Router = inject(Router);
		
	vm: any = undefined;
	navigationSubscription: Subscription = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.checkAccess();
		
		this.navigationSubscription = this.router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationEnd) {
					this.vm.tabCode = this.angularRoutingHelperService.getRouteParam('tabCode');
				}
			}
		);
	}
	
	ngOnDestroy() {
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
	}
	
	checkAccess() {
		this.routingService.validateAccess('insurance').then(() => {
			if (!this.angularRoutingHelperService.getRouteParam('tabCode')) {
				this.angularRoutingHelperService.setPath('/insurance/policies');
				return;
			}
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.tabCode = undefined;
		this.vm.isSmallSizeWindow = false;
		
		this.initWindowResizeHandler();
		this.initializeTabs();
	}
	
	initializeTabs() {
		this.vm.tabCode = this.angularRoutingHelperService.getRouteParam('tabCode');
	}
	
	initWindowResizeHandler() {
		$(window).resize(() => {
			var w: any = $(window).width();
			this.vm.isSmallSizeWindow = (w ? w <= 768 : false);
		});
	}
	
}